(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-mdl-curated-grid]').forEach(grid => {
      const cards = [...grid.querySelectorAll('[data-mdl-card]')];
      if (!cards.some((card, index) => index && card.dataset.group === cards[index - 1].dataset.group)) return;
      const remaining = cards.slice();
      const ordered = [];
      let previous = '';
      while (remaining.length) {
        const counts = new Map();
        remaining.forEach(card => counts.set(card.dataset.group, (counts.get(card.dataset.group) || 0) + 1));
        let chosen = -1, largest = -1;
        remaining.forEach((card, index) => {
          const count = counts.get(card.dataset.group);
          if (card.dataset.group !== previous && count > largest) { chosen = index; largest = count; }
        });
        if (chosen < 0) chosen = 0;
        const [card] = remaining.splice(chosen, 1);
        ordered.push(card);
        previous = card.dataset.group;
      }
      ordered.forEach(card => grid.append(card));
    });
    root.querySelectorAll('[data-mdl-card]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      card.addEventListener('click', e => {
        const button = e.target.closest('[data-mdl-swatch]');
        if (!button) return;
        card.querySelectorAll('[data-mdl-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        card.querySelectorAll('[data-mdl-link]').forEach(a => a.href = button.dataset.url);
        const image = card.querySelector('.mdl-card__image');
        if (image && button.dataset.image) {
          image.src = button.dataset.image;
          image.removeAttribute('srcset');
          image.alt = button.dataset.label || button.dataset.color;
        }
        const secondary = card.querySelector('.mdl-card__image--secondary');
        if (secondary) secondary.hidden = true;
        card.querySelector('[data-mdl-price]').textContent = button.dataset.price;
        card.querySelector('[data-mdl-color]').textContent = button.dataset.label || button.dataset.color;
        card.querySelector('[data-mdl-color]').dataset.mdlColor = button.dataset.color;
        const unavailable = card.closest('[data-mdl-look]')?.dataset.unavailable || (document.documentElement.lang.startsWith('fr') ? 'Indisponible' : 'Unavailable');
        card.querySelector('[data-mdl-availability]').textContent = button.dataset.available === 'true' ? '' : unavailable;
        const lookColor = card.closest('[data-look-item]')?.querySelector('[data-look-color]');
        if (lookColor) {
          lookColor.value = button.dataset.color;
          lookColor.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    root.querySelectorAll('[data-mdl-look]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('[data-look-form]');
      const submit = section.querySelector('[data-look-submit]');
      const status = section.querySelector('[data-look-status]');
      const items = [...section.querySelectorAll('[data-look-item]')].map(el => ({
        el, checkbox: el.querySelector('[data-look-include]'),
        selects: [...el.querySelectorAll('[data-look-option]')],
        variants: JSON.parse(el.querySelector('[data-look-variants]').textContent)
      }));
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: section.dataset.currency || 'EUR' });
      const refresh = () => {
        let total = 0, valid = true, count = 0;
        items.forEach(item => {
          const values = item.selects.map(s => s.value);
          item.variant = item.variants.find(v => v.options.every((o, i) => o === values[i]));
          const missing = values.some(v => !v);
          const card = item.el.querySelector('[data-mdl-card]');
          const shade = item.el.querySelector('[data-look-color]')?.value;
          if (shade && shade !== card.querySelector('[data-mdl-color]').dataset.mdlColor) {
            const preview = [...card.querySelectorAll('[data-mdl-swatch]')].find(b => b.dataset.color === shade);
            if (preview) preview.click();
            else if (item.variant?.featured_image?.src) {
              const image = card.querySelector('.mdl-card__image');
              image.src = item.variant.featured_image.src;
              image.removeAttribute('srcset');
              card.querySelector('[data-mdl-color]').textContent = item.el.querySelector('[data-look-color]').selectedOptions[0].textContent;
              card.querySelector('[data-mdl-color]').dataset.mdlColor = shade;
              const secondary = card.querySelector('.mdl-card__image--secondary');
              if (secondary) secondary.hidden = true;
            }
          }
          item.selects.forEach((select, index) => [...select.options].forEach(option => {
            if (!option.value) return;
            option.disabled = !item.variants.some(v => v.available && v.options[index] === option.value && v.options.every((o, i) => i === index || !values[i] || o === values[i]));
          }));
          item.el.querySelector('[data-look-state]').textContent = !item.checkbox.checked ? '' : missing ? section.dataset.choose : !item.variant?.available ? section.dataset.unavailable : formatter.format(item.variant.price / 100);
          if (item.checkbox.checked) {
            count++;
            if (item.variant?.available && !missing) total += item.variant.price;
            else valid = false;
          }
        });
        section.querySelector('[data-look-total]').textContent = formatter.format(total / 100);
        submit.disabled = !valid || !count;
      };
      form.addEventListener('change', refresh);
      document.addEventListener('change', e => {
        const picker = e.target.closest('variant-picker');
        const mainItem = items.find(item => item.el.hasAttribute('data-look-main'));
        if (!section.isConnected || !picker || !mainItem || picker.dataset.productId !== mainItem.el.dataset.productId) return;
        const optionName = e.target.dataset.optionName || e.target.name?.match(/^options\[(.+)\]$/)?.[1];
        const select = mainItem.selects.find(s => s.dataset.optionName === optionName);
        if (select && [...select.options].some(o => o.value === e.target.value)) {
          select.value = e.target.value;
          refresh();
        }
      });
      refresh();
      form.addEventListener('submit', async e => {
        e.preventDefault();
        refresh();
        if (submit.disabled) return;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
          const body = { items: items.filter(i => i.checkbox.checked).map(i => ({ id: i.variant.id, quantity: 1 })) };
          const response = await fetch(section.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || section.dataset.error);
          location.assign(section.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message || section.dataset.error;
          refresh();
        } finally { submit.removeAttribute('aria-busy'); }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();

